import { Page } from '@/core/architecture'

import { MailAuthTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * MailAuth Page
 * Implemented as a practical sample.
 */
export const MailAuth: Page = () => {
  const { state, actions } = useViewModel()

  return <MailAuthTemplate state={state} {...actions} />
}
